module.exports = __webpack_public_path__ + "img/btn-resultado-final.3c110b8a.png";